import { useAuth } from '_/contexts/AuthContext';

export default function useSystemAccess(systemRoles: string | string[]): boolean {
  const { checkSystemAccess } = useAuth();
  return checkSystemAccess(systemRoles);
}
